// extracted by mini-css-extract-plugin
module.exports = {"loggerOverlay":"LoggerOverlay_loggerOverlay__oDhOP"};